import { css as m, LitElement as g, nothing as p, html as l } from "lit";
import { property as d, queryAssignedElements as h, customElement as v } from "lit/decorators.js";
import { b as y } from "./styles-scZ6dVz-.js";
var u = Object.defineProperty, f = Object.getOwnPropertyDescriptor, s = (c, o, i, r) => {
  for (var t = r > 1 ? void 0 : r ? f(o, i) : o, n = c.length - 1, a; n >= 0; n--)
    (a = c[n]) && (t = (r ? a(o, i, t) : a(t)) || t);
  return r && t && u(o, i, t), t;
};
let e = class extends g {
  constructor() {
    super(...arguments), this.title = "", this.description = "";
  }
  get hasIcon() {
    return (this.iconNodes?.length ?? 0) > 0;
  }
  get hasActions() {
    return (this.actionNodes?.length ?? 0) > 0;
  }
  handleSlotChange() {
    this.requestUpdate();
  }
  render() {
    return l`
      <div class="empty-state">
        <div class="icon" ?hidden=${!this.hasIcon}>
          <slot name="icon" @slotchange=${this.handleSlotChange}></slot>
        </div>
        ${this.title ? l`<p class="title">${this.title}</p>` : p}
        ${this.description ? l`<p class="description">${this.description}</p>` : p}
        <slot></slot>
        <div class="actions" ?hidden=${!this.hasActions}>
          <slot name="actions" @slotchange=${this.handleSlotChange}></slot>
        </div>
      </div>
    `;
  }
};
e.styles = [
  y,
  m`
      :host {
        display: block;
      }

      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: var(--r5-space-2);
        padding: var(--r5-space-12);
        color: var(--r5-text-muted);
      }

      .icon {
        margin-bottom: var(--r5-space-2);
        color: var(--r5-text-muted);
      }

      .title {
        margin: 0;
        font-size: var(--r5-text-base);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
      }

      .description {
        margin: 0;
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
      }

      .actions {
        margin-top: var(--r5-space-4);
      }
    `
];
s([
  d({ type: String })
], e.prototype, "title", 2);
s([
  d({ type: String })
], e.prototype, "description", 2);
s([
  h({ slot: "icon" })
], e.prototype, "iconNodes", 2);
s([
  h({ slot: "actions" })
], e.prototype, "actionNodes", 2);
e = s([
  v("ark-empty-state")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-empty-state-CLezox8S.js.map
